import { render } from "./eja2.vue?vue&type=template&id=604f8f3d&scoped=true"
import script from "./eja2.vue?vue&type=script&lang=js"
export * from "./eja2.vue?vue&type=script&lang=js"

import "./eja2.vue?vue&type=style&index=0&id=604f8f3d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604f8f3d"]])

export default __exports__